function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7d1b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7d1b"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $a6049edf1cd52820$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"izUj7":"index.f7703eee.js","k7S9u":"play.817d9309.svg","4PvLp":"realisations.3ed0edcf.js"}'));


var $fhN3L = parcelRequire("fhN3L");

var $ilpIi = parcelRequire("ilpIi");
var $8c223f958e3057a8$exports = {};

$8c223f958e3057a8$exports = new URL((parcelRequire("27Lyk")).resolve("k7S9u"), import.meta.url).toString();


const $e73bf42412feb220$var$firebaseConfig = {
    apiKey: "AIzaSyCQ361NTWRRb3NDYlUvErc_fL6cdgMY1UU",
    authDomain: "laithier-portfolio.firebaseapp.com",
    projectId: "laithier-portfolio",
    storageBucket: "laithier-portfolio.appspot.com",
    messagingSenderId: "342872180046",
    appId: "1:342872180046:web:df5f26770e87534a4a8a1f"
};
const $e73bf42412feb220$var$app = (0, $fhN3L.initializeApp)($e73bf42412feb220$var$firebaseConfig);
const $e73bf42412feb220$var$db = (0, $ilpIi.getFirestore)($e73bf42412feb220$var$app);
let $e73bf42412feb220$var$allProjects;
const $e73bf42412feb220$var$initProjects = async ()=>{
    const projectsRef = (0, $ilpIi.collection)($e73bf42412feb220$var$db, "projects");
    const projectsDiv = document.querySelector(".projects");
    const q = (0, $ilpIi.query)(projectsRef, (0, $ilpIi.where)("isActive", "==", true));
    $e73bf42412feb220$var$allProjects = await (0, $ilpIi.getDocs)(q);
    $e73bf42412feb220$var$allProjects.forEach((doc)=>{
        let project = doc.data();
        projectsDiv.innerHTML += `
    <li id="${doc.id}" data-aos="fade-up" class="flex flex-col snap-center bg-white bg-opacity-5 rounded-2xl p-3 mr-8 hover:cursor-pointer project">
      <div class="-md:w-[342] -md:h-[180] w-[470] h-[248] block mb-6 relative">
      <img src="${project.photoUrl}" class="img absolute top-0 left-0 rounded-md h-full w-full transition-all duration-500">  
      <img class="play opacity-0 transition-all duration-500 absolute left-1/2 top-1/2 w-[40px] -translate-y-1/2 -translate-x-1/2" src="${0, (/*@__PURE__*/$parcel$interopDefault($8c223f958e3057a8$exports))}" alt="Lire la vidéo" />
      </div>

      <p class="mt-3 font-bold">${project.title}</p>

      <div class="flex justify-between text-[#656565] text-sm mt-6">
        <p>${project.place}</p>
        <p>${project.date}</p>
      </div>
    </li>
    `;
    });
};
const $e73bf42412feb220$var$initVideosHover = ()=>{
    document.querySelector(".overlay-bkg").addEventListener("click", ()=>{
        document.querySelector(".project-overlay").style.opacity = "0%";
        document.querySelector(".project-overlay").style.pointerEvents = "none";
        document.querySelector(".youtubeIframe").src = "";
    });
    document.querySelectorAll(".projects li").forEach((project)=>{
        project.addEventListener("click", ()=>{
            const projectData = $e73bf42412feb220$var$allProjects.docs.find((projectData)=>projectData.id === project.id);
            document.querySelector(".youtubeIframe").src = projectData.data().videoUrl;
            //project.querySelector("video").pause()
            document.querySelector(".project-overlay").style.opacity = "100%";
            document.querySelector(".project-overlay").style.pointerEvents = "all";
        });
        project.addEventListener("mouseover", ()=>{
            project.querySelector("img").style.opacity = "20%";
            project.querySelector(".play").style.opacity = "100%";
        });
        project.addEventListener("mouseout", ()=>{
            // project.querySelector("video").pause()
            //project.querySelector("video").currentTime = 0
            project.querySelector(".play").style.opacity = "0%";
            project.querySelector("img").style.opacity = "100%";
        });
    });
};
const $e73bf42412feb220$var$listenProjectsSlider = ()=>{
    const prevProjectBtn = document.querySelector(".prevProject");
    const nextProjectBtn = document.querySelector(".nextProject");
    const projects = document.querySelector(".projects");
    let currentProject = 1;
    const projectDivWidth = document.querySelector(".projects li").offsetWidth + 32;
    prevProjectBtn.addEventListener("click", ()=>{
        if (currentProject === 1) return;
        currentProject -= 1;
        if (currentProject === 1) prevProjectBtn.style.opacity = "50%";
        else prevProjectBtn.style.opacity = "100%";
        nextProjectBtn.style.opacity = "100%";
        projects.style.transform = `translateX(-${(currentProject - 1) * projectDivWidth}px)`;
    });
    nextProjectBtn.addEventListener("click", ()=>{
        const allProjects = document.querySelectorAll(".projects li");
        if (currentProject === allProjects.length - 1) return;
        prevProjectBtn.style.opacity = "100%";
        projects.style.transform = `translateX(-${currentProject * projectDivWidth}px)`;
        currentProject += 1;
        if (currentProject === allProjects.length - 1) nextProjectBtn.style.opacity = "50%";
        else nextProjectBtn.style.opacity = "100%";
    });
};
$e73bf42412feb220$var$initProjects().then(()=>{
    $e73bf42412feb220$var$initVideosHover();
    $e73bf42412feb220$var$listenProjectsSlider();
});


//# sourceMappingURL=index.f7703eee.js.map
